import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

/**
 * ★ REFERENCE ROUTES ★
 *
 * Pages load through `lazyRouteComponent`, so each module is its own JS chunk
 * and the initial bundle stays at the shell plus whatever screen was opened.
 *
 * `validateSearch` is why TanStack Router is here: downstream, `search.page` is
 * a clamped `number`, not a `string | null` every page has to re-parse.
 */
export const agenciesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/agencies',
  component: lazyRouteComponent(() => import('./pages/AgenciesListPage'), 'AgenciesListPage'),
  validateSearch: validateListSearch,
});

export const agencyDetailRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/agencies/$agencyId',
  component: lazyRouteComponent(() => import('./pages/AgencyDetailPage'), 'AgencyDetailPage'),
});

export const agenciesRoutes = [agenciesRoute, agencyDetailRoute];
